import * as Comlink from 'comlink'
import { CID } from 'multiformats/cid'

Comlink.transferHandlers.set('CID', {
	canHandle: (obj: unknown): obj is unknown => !!CID.asCID(obj),
	serialize: (cid: CID) => {
		return [{ bytes: cid.bytes }, []]
	},
	deserialize: (obj: any) => CID.decode(obj.bytes),
})
